<div class="title" #title>
  <div class="container container-max-width">
    <h1 class="h4">Planned Quota - Request Status</h1>
    <p>filter requests by alias or filter requests by my services</p>
  </div>
</div>
<div class="container container-content container-max-width" (window:resize)="onResize()" [style.height]="containerHeight">
  <div class="col-form-label">
    <div class="form-check form-check-inline">
      <input
        class="form-check-input"
        type="radio"
        id="mode1"
        [(ngModel)]="plannedQuotaQueryRequest.type"
        (change)="onAssignModeChanged()"
        name="radioMode"
        [value]="plannedQuotaQueryRequestType.Alias" />
      <label class="form-check-label" for="mode1">Submitted by me</label>
    </div>
    <div class="form-check form-check-inline">
      <input
        class="form-check-input"
        type="radio"
        id="mode2"
        [(ngModel)]="plannedQuotaQueryRequest.type"
        (change)="onAssignModeChanged()"
        name="radioMode"
        [value]="plannedQuotaQueryRequestType.Service" />
      <label class="form-check-label" for="mode2">Submitted for my services</label>
    </div>
    <a
      href="javascript:void(0)"
      class="topbar-item"
      (click)="exportExcel()"
      placement="top-right"
      container="body"
      ngbTooltip="Export to Excel"
      aria-label="Export to Excel">
      <span class="far fa-file-excel fa-lg"></span>
    </a>
  </div>
  <div class="landing-main mt-3">
    <grid-filter-pills [gridApi]="gridApi" *ngIf="gridApi"></grid-filter-pills>
    <ag-grid-angular
      #agGrid
      id="ViewGrid"
      style="width: 100%; height: 540px"
      class="ag-theme-balham"
      [masterDetail]="true"
      [gridOptions]="gridOptions"
      [rowData]="rowData"
      [excelStyles]="headerStyle"
      [pagination]="true"
      (gridReady)="onGridReady($event)">
    </ag-grid-angular>
  </div>
</div>
